import React, { useState } from "react";
import { message, Table, Modal, List, Button } from "@cloud/atom-ui";
import history from "@src/utils/history";
import { i18n } from "@src/utils/i18n";
import * as nls from "../../nls";
import "./sytle.less";
import CloudDownloadOutlined from "@cloud/atom-ui-icons/CloudDownloadOutlined";
import useMappedState from "@src/utils/useMappedState";
import { useNavigate } from "react-router-dom";
import { getBindUrl } from "../../thunk";
import { replaceHtmlDomain } from "@src/utils/common";
import { urlDomainDeal } from "@src/utils/common";
import DOMPurify from 'dompurify';

const I18N = i18n(nls);
const text = I18N;

export default props => {
  const {
    clickVersionItem,
    deleteColumn,
    paramsType,
    tableLoading,
    tableSource
  } = props;
  const { tenant = {} } = useMappedState("root");
  const navigate = useNavigate();

  const _pageSize = props.pageSize; // 显示条数
  const {
    queryParams: {
      query: { id, type }
    }
  } = history;
  const [appId, setAppId] = useState(id); // 获取appid
  const [downloadStatus, setDownloadStatus] = useState(false); // 下载弹窗显示隐藏
  const [downloadDetail, setDownloadDetail] = useState(null); // 下载列表
  const [previewStatus, setPreviewStatus] = useState(false); // 预审意见弹窗显示隐藏
  const [previewDetail, setPreviewDetail] = useState(null); // 下载列表
  const [pageSize, setPageSize] = useState(10); // 显示多少条
  const [count, setCount] = useState(1); // 总数

  // 申请上架校验租户认证和绑定相关
  // 未认证或未绑定状态提示对话框
  const [
    tenantInfoStatusModalVisible,
    setTenantInfoStatusModalVisible
  ] = useState(false);
  // 未认证或未绑定状态提示对话框 确定按钮跳转地址
  const [tenantGoUrl, setTenantGoUrl] = useState("");
  // 未认证或未绑定状态提示对话框 提示语
  const [tenantValidModalContent, setTenantValidModalContent] = useState("");
  // 未认证或未绑定状态提示对话框 确定按钮文字
  const [tenantValidModalButton, setTenantValidModalButton] = useState("确定");
  // 未认证或未绑定状态提示对话框 提示语和按钮文字 对象
  const tenantValidModalOpts = {
    0: {
      content:
        "发布WeLink第三方企业应用，需进行华为云账号绑定，申请成为WeLink服务商",
      button: "立即绑定"
    },
    1: {
      content: "发布WeLink第三方企业应用，需先申请成为WeLink服务商",
      button: "立即申请"
    },
    2: {
      content: "前往商品上架页面？",
      button: "确定"
    },
    3: {
      content: "发布WeLink第三方企业应用，需先申请成为WeLink服务商",
      button: "立即申请"
    }
  };

  // 审核状态对象 (1: 审核中; 2: 审核通过; 3: 审核被驳回)
  const auditStatus = {
    "1": {
      text: text.preving,
      color: "#faad14"
    },
    "2": {
      text: text.pass,
      color: "#5bccaa"
    },
    "3": {
      text: text.rejected,
      color: "#f45e61"
    }
  };

  const columns = [
    {
      align: "center",
      title: text.version,
      dataIndex: "versionName",
      width: "9%",
      render: (t, record) =>
        record.versionName ? <div>{record.versionName}</div> : "-"
    },
    {
      align: "center",
      title: text.submitBy,
      dataIndex: "submitBy",
      width: "9%",
      render: (t, record) =>
        record.submitBy ? <div>{record.submitBy}</div> : "-"
    },
    {
      align: "center",
      title: text.submitTime,
      dataIndex: "submitTime",
      width: "14%",
      render: (t, record) =>
        record.submitTime ? <div>{record.submitTime}</div> : "-"
    },
    {
      align: "center",
      title: text.previewFile,
      dataIndex: ["ucdFileName", "securityFileName", "functionalFileName"],
      render: (t, record) =>
        record.functionalFileName ||
          record.securityFileName ||
          record.ucdFileName ? (
          <p
            className="operate"
            style={{ cursor: "pointer", color: "rgb(13, 148, 255)" }}
            onClick={() => showDownload(record)}
          >
            {text.download}
          </p>
        ) : (
          "-"
        ),
      width: "9%"
    },
    {
      align: "center",
      title: text.preReviewDate,
      dataIndex: "preReviewDate",
      width: "14%",
      render: (t, record) =>
        record.preReviewDate ? <div>{record.preReviewDate}</div> : "-"
    },
    {
      align: "center",
      title: "预审状态",
      dataIndex: "preReviewStatus",
      width: "9%",
      render: (t, record) =>
        record.preReviewStatus ? (
          <span
            className="preReviewStatus"
            style={{
              color: auditStatus[record.preReviewStatus].color,
              border: `1px solid ${auditStatus[record.preReviewStatus].color}`
            }}
          >
            {auditStatus[record.preReviewStatus].text}
          </span>
        ) : (
          "-"
        )
    },
    {
      // 预审意见
      align: "center",
      title: text.preview,
      dataIndex: "auditMsg",
      className: "auditMsg",
      width: "9%",
      render: (t, record) => {
        if (record.auditMsg) {
          return (
            <p
              className="operate"
              style={{ cursor: "pointer", color: "rgb(13, 148, 255)" }}
              onClick={() => showPreview(record)}
            >
              查看
            </p>
          );
        }
        if (!record.auditMsg) {
          return <div style={{ marginLeft: "4px" }}>-</div>;
        }
      }
    },
    {
      align: "center",
      title: "审核附件",
      dataIndex: "auditFileName",
      render: (t, record) =>
        record.auditFileName ? (
          <a
            className="operate"
            href={record.auditFilePath}
            style={{ marginLeft: 17 }}
          >
            <CloudDownloadOutlined
              style={{ color: "#008DFF", marginRight: 8 }}
            />
            下载
          </a>
        ) : (
          <span>-</span>
        ),
      width: "7%"
    },
    {
      align: "center",
      title: "上架状态",
      dataIndex: "onShelfStatus",
      render: (t, record) => <span>{renderShelfStatusText(record)}</span>,
      width: "8%"
    },
    {
      align: "center",
      title: "操作",
      render: (t, record) => <span>{operateText(record)}</span>,
      width: "12%"
    }
  ];

  // 上架状态
  const renderShelfStatusText = record => {
    // 审核已通过
    if (record.preReviewStatus == 2) {
      if (record.onShelfStatus == 1) {
        return <span style={{ color: "rgb(102, 102, 102)" }}>已上架</span>;
      } else if (record.onShelfStatus == 0) {
        return <span style={{ color: "#FF8870" }}>未上架</span>;
      }
    }
    return <span>-</span>;
  };

  // 操作
  const operateText = record => {
    // 未提交预审-0  审核中-1  审核通过-2  审核失败-3
    // 审核中 审核失败
    if ([1, 3].includes(record.preReviewStatus)) {
      return "-";
    }
    // 待提交预审
    if (record.preReviewStatus == 0) {
      return (
        <div>
          <span
            className="operate"
            style={{
              color: "rgb(13, 148, 255)",
              cursor: "pointer",
              marginRight: 8
            }}
            onClick={() => {
              navigate(
                `/${paramsType}/appdetailV2/editionManage?id=${appId}&type=${paramsType}&versionStatus=preReview`
              );
            }}
          >
            提交预审
          </span>
          <span
            className="operate"
            style={{ cursor: "pointer", color: "#008dff" }}
            onClick={() => deleteColumn()}
          >
            删除
          </span>
        </div>
      );
    }
    if (record.preReviewStatus == 2) {
      // 审核通过未上架
      if (record.onShelfStatus == 0) {
        return (
          <div>
            <span
              className="operate"
              style={{
                color: "rgb(13, 148, 255)",
                cursor: "pointer",
                marginRight: 8
              }}
              onClick={() => applyForRelease(record)}
            >
              申请上架
            </span>
          </div>
        );
      } else if (record.onShelfStatus == 1) {
        // 审核通过已上架
        return "-";
      }
    }
  };

  // 申请上架
  const applyForRelease = record => {
    const { preReviewStatus } = record;
    // 待提交预审
    if (preReviewStatus === 0 || preReviewStatus === 3) {
      // 提交预审材料
      navigate(
        `/${paramsType}/appdetailV2/editionManage?id=${appId}&type=${paramsType}&versionStatus=preReview`
      );
    }
    // 预审通过，申请上架
    if (Object.keys(tenant).length) {
      const { welinkMarketStatus } = tenant;
      if (welinkMarketStatus !== 2) {
        setTenantInfoStatusModalVisible(true);
        setTenantValidModalContent(
          tenantValidModalOpts[welinkMarketStatus].content
        );
        setTenantValidModalButton(
          tenantValidModalOpts[welinkMarketStatus].button
        );
      }
      switch (welinkMarketStatus) {
        case 0:
          setTenantGoUrl(tenant.bindUrl);
          break;
        case 1:
        case 3:
          setTenantGoUrl(tenant.authUrl);
          break;
        case 2:
          window.open(tenant.authUrl);
          break;
        default:
          break;
      }
    } else {
      message.error("获取租户信息失败，请刷新重试");
    }
  };

  const handleApply = () => {
    getBindUrl().then(result => {
      if (result.status == 1) {
        const { welinkMarketStatus } = result.data;
        switch (welinkMarketStatus) {
          case 0:
            window.open(result.data.bindUrl);
            setTenantInfoStatusModalVisible(false);
            break;
          case 1:
          case 3:
            window.open(tenant.authUrl);
            setTenantInfoStatusModalVisible(false);
            break;
          case 2:
            window.open(tenant.authUrl);
            break;
          default:
            break;
        }
      } else {
        message.error(result.errMsg || "获取绑定地址失败");
      }
    });
  };

  const showDownload = params => {
    setDownloadStatus(true);
    const downArr = [
      {
        title: `1. ${params.functionalFileName}`,
        href: urlDomainDeal(params.functionalFilePath)
      },
      {
        title: `2. ${params.securityFileName}`,
        href: urlDomainDeal(params.securityFilePath)
      },
      {
        title: `3. ${params.ucdFileName}`,
        href: urlDomainDeal(params.ucdFilePath)
      }
    ];
    setDownloadDetail(downArr);
  };
  const showPreview = params => {
    setPreviewStatus(true);
    setPreviewDetail(params.auditMsg);
  };

  const pagination = {
    pageSize: _pageSize || pageSize,
    total: count,
    showSizeChanger: true,
    showQuickJumper: true
  };

  return (
    <>
      <div className="pre-record" style={{ padding: 0 }}>
        <Table
          loading={tableLoading}
          className="table-list"
          ellipsis={true}
          bordered
          columns={columns}
          dataSource={tableSource}
          pagination={pagination}
          onRow={record => {
            return {
              onClick: e => {
                if (e.target.className === "operate") {
                  return;
                } else {
                  clickVersionItem(record, appId, paramsType);
                }
              }
            };
          }}
        />
      </div>
      <Modal
        wrapClassName="confirm-modal"
        title={text.previewFile}
        visible={downloadStatus}
        onCancel={() => setDownloadStatus(false)}
        footer={null}
      >
        <List
          size="small"
          itemLayout="horizontal"
          dataSource={downloadDetail}
          renderItem={item => (
            <List.Item>
              <List.Item.Meta
                title={
                  <a
                    style={{ wordBreak: "break-all" }}
                    href={urlDomainDeal(item.href)}
                    download={item.title}
                  >
                    {item.title}
                  </a>
                }
              />
            </List.Item>
          )}
        />
      </Modal>

      <Modal
        wrapClassName="confirm-modal"
        title={text.preview}
        visible={previewStatus}
        onCancel={() => setPreviewStatus(false)}
        footer={[
          <Button key="back" onClick={() => setPreviewStatus(false)}>
            关闭
          </Button>
        ]}
      >
        <div>
          <pre
            className="preWrap"
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(replaceHtmlDomain(previewDetail)) }}
          ></pre>
        </div>
      </Modal>
      <Modal
        destroyOnClose={true}
        maskClosable={false}
        title="提示"
        visible={tenantInfoStatusModalVisible}
        width={500}
        centered={true}
        onOk={() => {
          handleApply();
        }}
        okText={tenantValidModalButton}
        onCancel={() => setTenantInfoStatusModalVisible(false)}
      >
        <div>{tenantValidModalContent}</div>
      </Modal>
    </>
  );
};
